import { createContext, useContext, useState } from "react";
import { UserDataV2 } from "@/models";

interface UsersContextType {
  users: UserDataV2[];
  setUsers: React.Dispatch<React.SetStateAction<UserDataV2[]>>;
}

const UsersContext = createContext<UsersContextType | null>(null);

export const UsersProvider = ({ children }: { children: React.ReactNode }) => {
  const [users, setUsers] = useState<UserDataV2[]>([]);

  return (
    <UsersContext.Provider value={{ users, setUsers }}>
      {children}
    </UsersContext.Provider>
  );
};

export function useUsersContext() {
  const context = useContext(UsersContext);
  if (!context) {
    throw new Error("useUsersContext deve ser usado dentro de UsersProvider");
  }
  return context;
}